import {getLingua} from "../auth"
function differenzaOrario({ dataInizio = undefined, dataFine = undefined,linguaPred=undefined }) {
const traduzioni = {
  ora: { 1: "ora", 2: "hour", 3: "Stunde", 4: "hora" },
  ore: { 1: "ore", 2: "hours", 3: "Stunden", 4: "horas" },
  minuti: { 1: "minuti", 2: "minutes", 3: "Minuten", 4: "minutos" },
  e: { 1: "e", 2: "and", 3: "und", 4: "y" }
};

  const diffMs = dataFine ? dataFine - dataInizio : dataInizio;
  const diffMin = Math.floor(diffMs / 60000);
  const ore = Math.floor(diffMin / 60);
  const minuti = diffMin % 60;
  const lang = linguaPred?linguaPred:parseInt(getLingua())||1;

  const t = {
    ora: traduzioni.ora[lang],
    ore: traduzioni.ore[lang],
    minuti: traduzioni.minuti[lang],
    e: traduzioni.e[lang],
  };
if (!(dataInizio===0 && dataFine===undefined)){
      if (minuti !== 0 && ore > 1)
        return `${ore} ${t.ore} ${t.e} ${minuti} ${t.minuti}`;
      else if (minuti === 0 && ore > 1)
        return `${ore} ${t.ore}`;
      else if (minuti === 0 && ore === 1)
        return `1 ${t.ora}`;
      else if (minuti !== 0 && ore === 1)
        return `1 ${t.ora} ${t.e} ${minuti} ${t.minuti}`;
      else if (minuti !== 0 && ore === 0)
        return `${minuti} ${t.minuti}`;
   }
   else {return 0}
}

export default differenzaOrario